<app-preview *ngIf="pia" [pia]="pia" [onlyData]="false">

</app-preview>
